import React from 'react';

/**
 * React component for the Footer Section.
 */
export const Footer = () => {
  return (
    <footer className="footer">
      <p></p>
    </footer>
  )
}
